import React from 'react';

import { DarkSkeleton } from '@eika/skeleton';

import { AccountRole } from '../../generated-types';
import { useTranslation } from '../../translations';

interface Props {
    accountRoles?: AccountRole[];
    isLoading: boolean;
}

const LoanOwnersDesktop: React.FC<Props> = ({ accountRoles, isLoading }) => {
    const { loanOwners: translated } = useTranslation();
    if (isLoading) {
        return <DarkSkeleton height={194} width="75%" className="loan-owners--skeleton" />;
    }

    if (!accountRoles) return null;

    return (
        <div className="loan-owners">
            <h2>{translated.title}</h2>
            {accountRoles.map((role) => (
                <dl key={translated.accountRole[role.accountRoleType] + role.customerName}>
                    <dt>{translated.accountRole[role.accountRoleType]}</dt>
                    <dd className="typography-subtitle loan-owners__value">{role.customerName}</dd>
                </dl>
            ))}
        </div>
    );
};

export default LoanOwnersDesktop;
